import * as React from "react";
import { TextField, Button } from "@material-ui/core";

export default function App() {
  return (
    <form>
      <TextField label="Email" />
      <TextField label="Password" type="password" />
      <Button type="submit">Submit</Button>
    </form>
  );
}
